import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import { KaimonoWebRoutes } from 'src/config/routes';
import { useCartQuantity } from 'src/hooks/useCartQuantity';
import { I18nContext } from 'src/stores/I18n';
import styles from './index.module.scss';

export const HeaderRight: React.FC = () => {
  const { cartTotalQuantity } = useCartQuantity();
  const [isMounted, setIsMounted] = useState(false);
  const localeResources = useContext(I18nContext);
  const cartLineCount = cartTotalQuantity ?? 0;
  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? (
    <div className={styles.container}>
      <Link href={KaimonoWebRoutes.cart}>
        <a aria-label={localeResources.cart.showToCart}>
          <div className={styles.menuBtn}>
            <span className={`${styles.menuBtnIcon} icon-cart`}></span>
            {cartLineCount > 0 ? <span className={styles.badge}>{cartLineCount}</span> : null}
          </div>
        </a>
      </Link>
    </div>
  ) : null;
};
